import React, { useState, useRef, useEffect } from 'react';
import './RetroTimePicker.css';

function RetroTimePicker({ value, onSelect, onClose }) {
  // Parse current time or default to now
  const currentTime = value ? new Date(value) : new Date();
  const [selectedHour, setSelectedHour] = useState(currentTime.getHours());
  const [selectedMinute, setSelectedMinute] = useState(currentTime.getMinutes());

  const hourRef = useRef(null);
  const minuteRef = useRef(null);

  // Generate hours (0-23)
  const hours = Array.from({ length: 24 }, (_, i) => i);

  // Generate minutes (0-59)
  const minutes = Array.from({ length: 60 }, (_, i) => i);

  // Scroll selected items into view on mount
  useEffect(() => {
    if (hourRef.current) {
      const selectedElement = hourRef.current.querySelector('.selected');
      if (selectedElement) {
        selectedElement.scrollIntoView({ block: 'center', behavior: 'auto' });
      }
    }
    if (minuteRef.current) {
      const selectedElement = minuteRef.current.querySelector('.selected');
      if (selectedElement) {
        selectedElement.scrollIntoView({ block: 'center', behavior: 'auto' });
      }
    }
  }, []);

  const handleNow = () => {
    const now = new Date();
    setSelectedHour(now.getHours());
    setSelectedMinute(now.getMinutes());
  };

  const handleConfirm = () => {
    // Create a date object with the selected time
    const date = value ? new Date(value) : new Date();
    date.setHours(selectedHour);
    date.setMinutes(selectedMinute);
    date.setSeconds(0);
    date.setMilliseconds(0);
    onSelect(date);
  };

  const formatNumber = (num) => String(num).padStart(2, '0');

  return (
    <div className="retro-time-overlay" onClick={onClose}>
      <div className="retro-time-popup" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="retro-time-header">
          <div className="retro-time-title">
            ZEIT WÄHLEN
          </div>
        </div>

        {/* Quick action */}
        <div className="retro-time-quick-actions">
          <button type="button" onClick={handleNow} className="retro-time-now-btn">
            JETZT
          </button>
        </div>

        {/* Time display */}
        <div className="retro-time-display">
          {formatNumber(selectedHour)}:{formatNumber(selectedMinute)}
        </div>

        {/* Time picker */}
        <div className="retro-time-picker">
          {/* Hours */}
          <div className="retro-time-column">
            <div className="retro-time-column-label">STUNDEN</div>
            <div className="retro-time-list" ref={hourRef}>
              {hours.map(hour => (
                <button
                  key={hour}
                  type="button"
                  onClick={() => setSelectedHour(hour)}
                  className={`retro-time-item ${selectedHour === hour ? 'selected' : ''}`}
                >
                  {formatNumber(hour)}
                </button>
              ))}
            </div>
          </div>

          {/* Separator */}
          <div className="retro-time-separator">:</div>

          {/* Minutes */}
          <div className="retro-time-column">
            <div className="retro-time-column-label">MINUTEN</div>
            <div className="retro-time-list" ref={minuteRef}>
              {minutes.map(minute => (
                <button
                  key={minute}
                  type="button"
                  onClick={() => setSelectedMinute(minute)}
                  className={`retro-time-item ${selectedMinute === minute ? 'selected' : ''}`}
                >
                  {formatNumber(minute)}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="retro-time-footer">
          <button type="button" onClick={onClose} className="retro-time-cancel-btn">
            ABBRECHEN
          </button>
          <button type="button" onClick={handleConfirm} className="retro-time-confirm-btn">
            BESTÄTIGEN
          </button>
        </div>
      </div>
    </div>
  );
}

export default RetroTimePicker;
